import { UserClient } from '../types'
import { GetUserResponseData } from '../types'

type User = {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
}

export const update = (base: UserClient) => (user: Partial<User>) =>
  base.requester.put<GetUserResponseData>('', user, { withCredentials: true })
